import { type OrderIngredient } from '@hungryroot/orders';
import { type PairingV1 as Pairing } from '@hungryroot/rest';
import { AuthGuard } from '../../auth/AuthGuard/AuthGuard';
import { Ingredient, IngredientVariant } from '../../Ingredient/Ingredient';
import { FavoriteButton } from '../FavoriteButton/FavoriteButton';
import { RDP } from '../RDP/RDP';
import { RdpHeader } from '../RdpHeader/RdpHeader';

export type Props = {
  testid?: string;
  pairing: Pairing;
  modifiedIngredientIds?: number[];
};

export function FavoritableModifiedIngredientsRdp(props: Props) {
  const { pairing, modifiedIngredientIds } = props;

  const isRemoved = (ingredient: OrderIngredient) => {
    return !modifiedIngredientIds?.includes(ingredient.id);
  };

  return (
    <RDP
      imageOverlay={
        <AuthGuard
          authenticated={(auth) => {
            return (
              <FavoriteButton pairing={pairing} customer={auth.customerData} />
            );
          }}
        />
      }
      ingredients={
        <>
          <RdpHeader title="Ingredients" />
          {pairing.ingredients.map((ingredient) => {
            return (
              <Ingredient
                key={ingredient.id}
                variant={
                  modifiedIngredientIds && isRemoved(ingredient)
                    ? IngredientVariant.Removed
                    : undefined
                }
                ingredient={ingredient}
              />
            );
          })}
        </>
      }
      pairing={pairing}
    />
  );
}
